// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".goTop[data-v-7965b556] {\n  position: fixed;\n  bottom: 50px;\n  right: 50px;\n  border-radius: 50%;\n}\n.goTop .img[data-v-7965b556] {\n  width: 60px;\n  height: auto;\n}\n.markdown-body[data-v-7965b556] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  min-width: 200px;\n}\n", ""]);
// Exports
module.exports = exports;
